import { TooltipProps } from 'recharts'
import { translateSeriesName } from '@/common/utils/seriesNameTranslator'
import { barChartLabelFormatter } from '@/common/utils/barChartLabelFormatter'
import { ChartData } from '@/common/types/chart.type'

type customChartTooltipProps = TooltipProps<any, any> & {
  seriesSettings: ChartData['series_settings']
}

const CustomChartTooltip = ({ active, payload, label, seriesSettings }: customChartTooltipProps) => {
  if (!active || !payload?.length) return null

  const filteredPayload = payload.filter(item => item?.value !== null && item.value !== 0)

  if (!filteredPayload.length) return null

  return (
    <div className="bg-slate-300 rounded-lg px-3 py-2 text-[12px] text-black shadow-[0_2px_6px_rgba(0,0,0,0.15)] space-y-1">
      <p className="font-semibold">{label}</p>
      {filteredPayload.map((item, i) => (
        <div key={i} className="flex items-center">
          <div className="w-2 h-2 rounded-full" style={{ backgroundColor: item.color }} />
          <span>
            {translateSeriesName(item.name || '')}:{' '}
            {barChartLabelFormatter(item.value ?? 0, seriesSettings[item.name || '']?.format_parser)}
          </span>
        </div>
      ))}
    </div>
  )
}

export default CustomChartTooltip;

export const CustomChartLabel = ({ x, y, width, height, value, format_parser }: any) => {
  const formatted = barChartLabelFormatter(value, format_parser)

  if (width < 30) return null
  const fontSize = 10
  const textY = height > 20 ? y + height / 2 + fontSize / 2 : y - 5
  const textAnchor = 'middle'
  const textX = x + width / 2

  return (
    <text x={textX} y={textY} fill="#fff" fontSize={fontSize} textAnchor={textAnchor}>
      {formatted}
    </text>
  )
}